<div id="layoutHome" class="web-center" style="margin-top: 40px; margin-bottom: 40px;">
    <div class="row" style="display: flex; justify-content: center; margin-bottom: 20px;">
        <div class="col-md-8 web-left" style="padding: 40px;">
            
            <p><strong><span style="font-size:16pt;">Our Privacy Policy</span></strong></p>
            <p>
                <strong><span style="font-size:10pt;">Effective Date:</span></strong> 21 July 2025
                <br>
                <strong><span style="font-size:10pt;">Last Updated:</span></strong> 01 January 2026
            </p>

            <br> <!-- next section-->

            <p><strong><span style="font-size:16pt;">1. Introduction</span></strong></p>
            <p><span style="font-size:10pt;">This Privacy Policy explains how <strong> Group Ltd trading as Nutrigenic </strong> (“Nutrigenic”, “we”, “us”, or “our”) collects, uses, stores and protects your personal data when you:  </span></p>
            <ul>
                <li><p><span style="font-size:10pt;">Visit our website</span></p></li>
                <li><p><span style="font-size:10pt;">Create an account</span></p></li>
                <li><p><span style="font-size:10pt;">Subscribe to our services</span></p></li>
                <li><p><span style="font-size:10pt;">Purchase our products</span></p></li>
            </ul>

            <p><span style="font-size:10pt;">We are committed to protecting your privacy and processing personal data in accordance with:</span></p>
            <ul>
                <li><p><span style="font-size:10pt;"><strong>UK General Data Protection Regulation (UK GDPR)</strong></span></p></li>
                <li><p><span style="font-size:10pt;"><strong>Data Protection Act 2018</strong></span></p></li>
            </ul>

            <p><span style="font-size:10pt;">This Privacy Policy explains:</span></p>
            <ul>
                <li><p><span style="font-size:10pt;">What personal data we collect</span></p></li>
                <li><p><span style="font-size:10pt;">How we use your personal data</span></p></li>
                <li><p><span style="font-size:10pt;">The legal basis for processing your data</span></p></li>
                <li><p><span style="font-size:10pt;">How we protect and store your information</span></p></li>
                <li><p><span style="font-size:10pt;">How cookies are used on our website</span></p></li>
                <li><p><span style="font-size:10pt;">Your rights regarding your personal data</span></p></li>
            </ul>

            <br> <!-- next section-->

            <p><strong><span style="font-size:16pt;">2. Information About Us</span></strong></p>
            <p><span style="font-size:10pt;">The Nutrigenic brand and services are operated by:</span></p>

            <p>
                <strong><span style="font-size:10pt;">Company Name:</span></strong> Nutrigenic Group Ltd<br>
                <strong><span style="font-size:10pt;">Trading Name:</span></strong> Nutrigenic
            </p>

            <p><strong><span style="font-size:10pt;">Registered Office:</span></strong><br>
            <span style="font-size:10pt;">6th Floor, Amp House, Dingwall Road<br>Croydon, United Kingdom, CR0 2LX</span></p>

            <p><strong><span style="font-size:10pt;">Company Number:</span></strong> 16586665</p>
            <p><span style="font-size:10pt;">If you have any questions regarding this Privacy Policy or your personal data, please contact:</span></p>

            <p><strong><span style="font-size:10pt;">Email:</span></strong> <a href="mailto:support@nutrigenic.co.uk" style="color: orange;"> support@nutrigenic.co.uk</a></p>


            <br> <!-- next section-->

            <p><strong><span style="font-size:16pt;">3. Data Protection Principles</span></strong></p>
            <p><span style="font-size:10pt;">We process personal data in accordance with the principles of UK GDPR. This means that personal data is:</span></p>

            <ul>
                <li><p><span style="font-size:10pt;">Processed <strong>lawfully, fairly and transparently</strong></span></p></li>
                <li><p><span style="font-size:10pt;">Collected for <strong>specified and legitimate purposes</strong></span></p></li>
                <li><p><span style="font-size:10pt;"><strong>Adequate, relevant and limited </strong>to what is necessary</span></p></li>
                <li><p><span style="font-size:10pt;"><strong>Accurate and kept up to date</strong></span></p></li>
                <li><p><span style="font-size:10pt;"><strong>Not retained longer than necessary</strong></span></p></li>
                <li><p><span style="font-size:10pt;"><strong>Protected against unauthorised access, loss or misuse</strong></span></p></li>
            </ul>


            <br> <!-- next section-->

            <p><strong><span style="font-size:16pt;">4. Personal Data We Collect</span></strong></p>
            <p><span style="font-size:10pt;">We may collect information in several ways when you interact with Nutrigenic.</span></p>

            <br>

            <p><strong><span style="font-size:12pt;">4.1 Information You Provide</span></strong></p>
            <p><span style="font-size:10pt;">When creating an account, placing an order or contacting us we may collect:</span></p>
            <ul>
                <li><p><span style="font-size:10pt;">Full name</span></p></li>
                <li><p><span style="font-size:10pt;">Email address</span></p></li>
                <li><p><span style="font-size:10pt;">Phone number</span></p></li>
                <li><p><span style="font-size:10pt;">Delivery address</span></p></li>
                <li><p><span style="font-size:10pt;">Billing address</span></p></li>
                <li><p><span style="font-size:10pt;">Account login credentials</span></p></li>
            </ul>

            <br>
            
            <p><strong><span style="font-size:12pt;">4.2 Subscription and Order Information</span></strong></p>
            <p><span style="font-size:10pt;">When using our services we may collect:</span></p>
            <ul>
                <li><p><span style="font-size:10pt;">Meal selections</span></p></li>
                <li><p><span style="font-size:10pt;">Dietary preferences</span></p></li>
                <li><p><span style="font-size:10pt;">Order history</span></p></li>
                <li><p><span style="font-size:10pt;">Delivery instructions</span></p></li>
                <li><p><span style="font-size:10pt;">Subscription status</span></p></li>
                <li><p><span style="font-size:10pt;">Customer service communications</span></p></li>
            </ul>

            <p><span style="font-size:10pt;">This information helps us manage your account, process orders and improve our services.</span></p>

            <br>
            
            <p><strong><span style="font-size:12pt;">4.3 Nutrition and Lifestyle Information</span></strong></p>
            <p><span style="font-size:10pt;">To support personalised nutrition recommendations, we may request optional information including:</span></p>
            <ul>
                <li><p><span style="font-size:10pt;">Age</span></p></li>
                <li><p><span style="font-size:10pt;">Height</span></p></li>
                <li><p><span style="font-size:10pt;">Weight</span></p></li>
                <li><p><span style="font-size:10pt;">Dietary or fitness goals</span></p></li>
            </ul>

            <p><span style="font-size:10pt;">Providing this information is voluntary and is used solely to help tailor your meal plan experience.</span></p>

            <br>
            
            <p><strong><span style="font-size:12pt;">4.4 Payment Information</span></strong></p>
            <p><span style="font-size:10pt;">Payments are processed securely through <strong>third-party payment providers.</strong></span></p>
            <p><span style="font-size:10pt;">Nutrigenic <strong>does not store full debit or credit card numbers.</strong></span></p>
            <p><span style="font-size:10pt;">Payment providers may collect billing information necessary to process transactions. </span></p>

            <br>
            
            <p><strong><span style="font-size:12pt;">4.5 Website Usage Data</span></strong></p>
            <p><span style="font-size:10pt;">When you visit our website, we may automatically collect technical data such as:</span></p>
            <ul>
                <li><p><span style="font-size:10pt;">IP address</span></p></li>
                <li><p><span style="font-size:10pt;">Device type</span></p></li>
                <li><p><span style="font-size:10pt;">Browser type</span></p></li>
                <li><p><span style="font-size:10pt;">Pages visited</span></p></li>
                <li><p><span style="font-size:10pt;">Website interaction data</span></p></li>
            </ul>

            <p><span style="font-size:10pt;">This helps us improve website functionality and user experience.</span></p>

            <br> <!-- next section-->
            
            <p><strong><span style="font-size:16pt;">5. Cookies and Tracking Technologies</span></strong></p>
            <p><span style="font-size:10pt;">Our website uses cookies and similar technologies to:</span></p>
            <ul>
                <li><p><span style="font-size:10pt;">Improve website functionality</span></p></li>
                <li><p><span style="font-size:10pt;">Analyse website traffic</span></p></li>
                <li><p><span style="font-size:10pt;">Remember user preferences</span></p></li>
                <li><p><span style="font-size:10pt;">Deliver relevant marketing content</span></p></li>
            </ul>

            <p><span style="font-size:10pt;">Cookies are small text files placed on your device when you visit a website. They allow websites to recognise your device and remember certain information about your visit.</span></p>

            <br> <!-- next section-->
            
            <p><strong><span style="font-size:16pt;">6. Types of Cookies We Use</span></strong></p>

            <p><span style="font-size:10pt;"><strong>Essential Cookies</strong></span></p>
            <p><span style="font-size:10pt;">These cookies are required for the operation of our website, including:</span></p>
            <ul>
                <li><p><span style="font-size:10pt;">Account login functionality</span></p></li>
                <li><p><span style="font-size:10pt;">Security features</span></p></li>
                <li><p><span style="font-size:10pt;">Subscription management</span></p></li>
                <li><p><span style="font-size:10pt;">Shopping cart functionality</span></p></li>
            </ul>

            <p><span style="font-size:10pt;">Without these cookies the website may not function properly.</span></p>

            <br>

            <p><span style="font-size:10pt;"><strong>Analytics Cookies</strong></span></p>
            <p><span style="font-size:10pt;">Analytics cookies help us understand how visitors interact with our website, including:</span></p>
            <ul>
                <li><p><span style="font-size:10pt;">Pages visited</span></p></li>
                <li><p><span style="font-size:10pt;">Time spent on pages</span></p></li>
                <li><p><span style="font-size:10pt;">Website performance</span></p></li>
            </ul>

            <p><span style="font-size:10pt;">This information helps us improve our services.</span></p>

            <br>

            <p><span style="font-size:10pt;"><strong>Functionality Cookies</strong></span></p>
            <p><span style="font-size:10pt;">These cookies remember choices you make on our website such as:</span></p>
            <ul>
                <li><p><span style="font-size:10pt;">Language preferences</span></p></li>
                <li><p><span style="font-size:10pt;">Login information</span></p></li>
                <li><p><span style="font-size:10pt;">User settings</span></p></li>
            </ul>

            <br>

            <p><span style="font-size:10pt;"><strong>Marketing  Cookies</strong></span></p>
            <p><span style="font-size:10pt;">Marketing cookies help us:</span></p>
            <ul>
                <li><p><span style="font-size:10pt;">Deliver relevant advertising</span></p></li>
                <li><p><span style="font-size:10pt;">Login informationMeasure marketing performance</span></p></li>
                <li><p><span style="font-size:10pt;">Understand customer interests</span></p></li>
            </ul>

            <br> <!-- next section-->
            
            <p><strong><span style="font-size:16pt;">7. Managing Your Cookie Preferences</span></strong></p>

            <p><span style="font-size:10pt;">You can manage or restrict cookies that are set by our website through your browser settings</span></p>
            <p><span style="font-size:10pt;">Most web browsers allow you to:</span></p>
            <ul>
                <li><p><span style="font-size:10pt;">View the cookies stored on your device</span></p></li>
                <li><p><span style="font-size:10pt;">Delete existing cookies</span></p></li>
                <li><p><span style="font-size:10pt;">Block cookies from certain websites</span></p></li>
                <li><p><span style="font-size:10pt;">Block all cookies</span></p></li>
            </ul>

            <p><span style="font-size:10pt;">If you wish to learn more about managing cookies, including how to delete them or adjust browser settings across different devices and browsers, you can visit:</span></p>

            <p><a href="https://www.internetcookies.com" style="font-size:10pt;">https://www.internetcookies.com</a></p>
            <p><span style="font-size:10pt;">This website provides detailed information on controlling cookies for a wide range of browsers and devices.</span></p>
            <p><span style="font-size:10pt;">Please note that if you disable or block certain cookies, some parts of our website may not function properly. This may include:</span></p>
            <ul>
                <li><span style="font-size:10pt;">Login functionality</span></li>
                <li><span style="font-size:10pt;">Account preferences</span></li>
                <li><span style="font-size:10pt;">Shopping or subscription features</span></li>
                <li><span style="font-size:10pt;">Personalised content</span></li>
            </ul>

            <p><span style="font-size:10pt;">As a result, some features of the Nutrigenic website may not be available or may not work as intended.</span></p>

            <br> <!-- next section-->
            
            <p><strong><span style="font-size:16pt;">8. Updating Your Cookie Preferences</span></strong></p>

            <p><span style="font-size:10pt;">Where applicable, you may update your cookie preferences at any time through the <strong>cookie settings or consent banner available on our website.</strong></span></p>
            <p><span style="font-size:10pt;">This allows you to review and adjust which categories of cookies you consent to.</span></p>

            <br> <!-- next section-->
            
            <p><strong><span style="font-size:16pt;">9. How We Use Personal Data</span></strong></p>

            <p><span style="font-size:10pt;">We may use personal data for the following purposes:</span></p>
            
            <ul>
                <li><p><span style="font-size:10pt;">Processing orders and delivering meals</span></p></li>
                <li><p><span style="font-size:10pt;">Managing subscriptions and payments</span></p></li>
                <li><p><span style="font-size:10pt;">Providing personalised nutrition recommendations</span></p></li>
                <li><p><span style="font-size:10pt;">Customer support and service communications</span></p></li>
                <li><p><span style="font-size:10pt;">Improving our products and services</span></p></li>
                <li><p><span style="font-size:10pt;">Internal analytics and record keeping</span></p></li>
                <li><p><span style="font-size:10pt;">Marketing communications where permitted</span></p></li>
                <li><p><span style="font-size:10pt;">Fraud detection and prevention</span></p></li>
                <li><p><span style="font-size:10pt;">Compliance with legal obligation</span></p></li>
            </ul>

            <br> <!-- next section-->
            
            <p><strong><span style="font-size:16pt;">10. Legal Basis for Processing</span></strong></p>

            <p><span style="font-size:10pt;">Under UK GDPR we rely on the following lawful bases:</span></p>

            <p><span style="font-size:10pt;"><strong>Contractual Necessity</strong></span></p>
            <p><span style="font-size:10pt;">To provide the services you request and manage your account.</span></p>

            <p><span style="font-size:10pt;"><strong>Legitimate Interests</strong></span></p>
            <p><span style="font-size:10pt;">To operate and improve our services and business.</span></p>

            <p><span style="font-size:10pt;"><strong>Consent</strong></span></p>
            <p><span style="font-size:10pt;">Where you agree to receive marketing communications or provide optional personal information.</span></p>

            <p><span style="font-size:10pt;"><strong>Legal Obligation</strong></span></p>
            <p><span style="font-size:10pt;">Where we must process personal data to comply with legal requirements.</span></p>
            
            <br> <!-- next section-->
            
            <p><strong><span style="font-size:16pt;">11. Sharing Personal Data</span></strong></p>

            <p><span style="font-size:10pt;">We may share personal data with trusted third-party service providers including:</span></p>
            
            <ul>
                <li><p><span style="font-size:10pt;">Payment processors</span></p></li>
                <li><p><span style="font-size:10pt;">Delivery partners</span></p></li>
                <li><p><span style="font-size:10pt;">IT and hosting providers</span></p></li>
                <li><p><span style="font-size:10pt;">Marketing platforms</span></p></li>
                <li><p><span style="font-size:10pt;">Customer support systems</span></p></li>
            </ul>

            <p><span style="font-size:10pt;">These providers may only process your data for authorised purposes and must comply with data protection laws.</span></p>
            <p><span style="font-size:10pt;">We <strong>do not sell personal data </strong>to third parties.</span></p>

            <br> <!-- next section-->
            
            <p><strong><span style="font-size:16pt;">12. International Data Transfers</span></strong></p>

            <p><span style="font-size:10pt;">Some service providers may process personal data outside the UK or European Economic Area.</span></p>
            <p><span style="font-size:10pt;">Where this occurs, we ensure appropriate safeguards are implemented to protect your personal data.</span></p>

            <br>
            
            <p><strong><span style="font-size:16pt;">13. International Data Transfers</span></strong></p>

            <p><span style="font-size:10pt;">We take appropriate technical and organisational measures to protect personal data from:</span></p>
            <ul>
                <li><p><span style="font-size:10pt;">Unauthorised access</span></p></li>
                <li><p><span style="font-size:10pt;">Loss or misuse</span></p></li>
                <li><p><span style="font-size:10pt;">Data breaches</span></p></li>
            </ul>
            <p><span style="font-size:10pt;">These measures include secure systems, restricted access and internal security procedures.</span></p>
            <p><span style="font-size:10pt;">However, no method of internet transmission can be guaranteed to be completely secure.</span></p>

            <br> <!-- next section-->
            
            <p><strong><span style="font-size:16pt;">14. Data Retention</span></strong></p>

            <p><span style="font-size:10pt;">We retain personal data only for as long as necessary to fulfil the purposes outlined in this policy.</span></p>
            <p><span style="font-size:10pt;">In most cases personal data will not be retained longer than <strong>six (6) years</strong>, unless required by law.</span></p>

            <br> <!-- next section-->
            
            <p><strong><span style="font-size:16pt;">15. Your Rights Under UK GDPR</span></strong></p>

            <p><span style="font-size:10pt;">Under UK data protection law, you have the right to:</span></p>
            <ul>
                <li><p><span style="font-size:10pt;">Be informed about how your data is used</span></p></li>
                <li><p><span style="font-size:10pt;">Access your personal data</span></p></li>
                <li><p><span style="font-size:10pt;">Correct inaccurate information</span></p></li>
                <li><p><span style="font-size:10pt;">Request deletion of your data</span></p></li>
                <li><p><span style="font-size:10pt;">Restrict processing of your data</span></p></li>
                <li><p><span style="font-size:10pt;">Request data portability</span></p></li>
                <li><p><span style="font-size:10pt;">Object to certain processing activities</span></p></li>
                <li><p><span style="font-size:10pt;">Withdraw consent for marketing communications</span></p></li>
            </ul>
            <p><span style="font-size:10pt;">Requests can be made by contacting us.</span></p>

            <br> <!-- next section-->
            
            <p><strong><span style="font-size:16pt;">16. Links to Third-Party Websites</span></strong></p>

            <p><span style="font-size:10pt;">Our website may contain links to external websites</span></p>
            <p><span style="font-size:10pt;">Once you leave our website, we are not responsible for the privacy practices of those websites.</span></p>

            <br> <!-- next section-->
            
            <p><strong><span style="font-size:16pt;">17. Children’s Privacy</span></strong></p>

            <p><span style="font-size:10pt;">Our services are not intended for individuals under <strong>18 years of age</strong></span></p>
            <p><span style="font-size:10pt;">We do not knowingly collect personal data from minors.</span></p>

            <br> <!-- next section-->
            
            <p><strong><span style="font-size:16pt;">18. Changes to This Privacy Policy</span></strong></p>

            <p><span style="font-size:10pt;">We may update this Privacy Policy from time to time</span></p>
            <p><span style="font-size:10pt;">The latest version will always be available on our website with the updated revision date.</span></p>

            <br> <!-- next section-->
            
            <p><strong><span style="font-size:16pt;">19. Contact Us</span></strong></p>

            <p><span style="font-size:10pt;">If you have any questions about this Privacy Policy or wish to exercise your data rights, please contact:</span></p>
            <p><span style="font-size:10pt;"><strong>Email:</strong> <a href="mailto:support@nutrigenic.co.uk" style="color: orange;"> support@nutrigenic.co.uk</a></span></p>

            <p>
                <span style="font-size:10pt;"><strong>Company:</strong><br>
                Nutrigenic Group Ltd<br>
                6th Floor, Amp House, Dingwall Road<br>
                Croydon, United Kingdom, CR0 2LX
                </span>
            </p>

            <p>
                <span style="font-size:10pt;">Company Number: <strong>16586665</strong></span></p>

        </div>
    </div>
</div>